import { createReducer } from 'redux-act';
export var key = 'Thankyou';

//
// Initial state
//
var initialState = {};

//
// Actions
//
export var actions = {};

//
// Reducer
//
export var reducer = createReducer({}, initialState);

//
// Selectors
//
// const root = (state) => state[key]

export var selectors = {};